import React from 'react';
import { Section, SectionTitle } from '../Section';
import { CtaBlock } from '../CtaBlock';
import { manuals } from '../../data/content';
export function Manuals() {
  return <Section tone="panel" data-id="element-188" data-mp="o550mmnxlfjc">
      <SectionTitle eyebrow="📦 Everything you need to stop improvising" data-id="element-189" data-mp="o4bqdbprk7wg">
        6 Master Manuals
      </SectionTitle>

      <ol className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-190" data-mp="j58yksysny6f">
        {manuals.map(manual => <li key={manual.number} className="flex flex-col rounded-2xl border border-white/10 bg-ink-800 p-5" data-id="element-191" data-mp="e8ihc2b96wjf">
            <span className="font-display text-4xl font-bold leading-none text-teal/60" data-id="element-192" data-mp="55zgtouxww0c">
              {manual.number}
            </span>
            <h3 className="mt-2 font-display text-xl font-bold uppercase leading-tight text-white" data-id="element-193" data-mp="8hi0ramzx62">
              {manual.title}
            </h3>
            <p className="mt-2 text-[15px] leading-snug text-white/65" data-id="element-194" data-mp="1zhxohmdlpju4">
              {manual.description}
            </p>
          </li>)}
      </ol>

      <CtaBlock className="mt-10" headline="Get all 6 Master Manuals in minutes" data-id="element-195" data-mp="1cjqskb274dbe" />
    </Section>;
}